import ApiBase from "../api-base";

class CompaniesApi extends ApiBase {
    async getCompany(id) {
        const response = await this.get(`/companies/${id}`);

        return response.data;
    }

    async upcomingBookings(id) {
        const response = await this.get(`/companies/${id}/upcoming-bookings`);

        return response.data;
    }

    async getAvailableMemberships(id) {
        const response = await this.get(`/companies/${id}/available-memberships`);

        return response.data;
    }

    async getIndustries() {
        const response = await this.get(`/companies/industries`);

        return response.data;
    }

    async getCompanyMembers(id, params) {
        const response = await this.get(`/companies/${id}/users`, params);

        return response.data;
    }

    async getCreditsUsage(id) {
        const response = await this.get(`/companies/${id}/credits/year`);

        return response.data;

    }

    async getCompanyEvents(id) {
        const response = await this.get(`/companies/${id}/event-bookings`);

        return response.data;
    }

    async getBillingProfiles(id, params) {
        const response = await this.get(`/companies/${id}/billing-profiles`, params);

        return response.data;
    }

    async getReceipts(id, params) {
        const response = await this.get(`/companies/${id}/receipts`, params);

        return response.data;
    }

    async getCreditDebits(id, params) {
        const response = await this.get(`/companies/${id}/credits/debits`, params);

        return response.data;
    }

    async userInvites(id, params) {
        const response = await this.get(`/companies/${id}/user-invites`, params);

        return response.data;
    }

    async user(id, userId, params) {
        const response = await this.get(`/companies/${id}/users/${userId}`, params);

        return response.data;
    }

    async userActions(id, userId, params) {
        const response = await this.get(`/companies/${id}/users/${userId}/actions`, params);

        return response.data;
    }

     async search(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/companies/${id}/search`, params, validationHandler);
            return response.data;
        });
    }

    async updateBillingProfile(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/companies/${id}/billing-profile`, params, validationHandler);
            return response.data;
        });
    }

    async update(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/companies/${id}`, params, validationHandler);
            return response.data;
        });
    }

    async updateProfile(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/companies/${id}/profile`, params, validationHandler);
            return response.data;
        });
    }

    async inviteUser(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/companies/${id}/invite-user`, params, validationHandler);
            return response.data;
        });
    }

    async updateUserRoles(id, userId, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/companies/${id}/users/${userId}/roles`, params, validationHandler);
            return response.data;
        });
    }

    async deleteUserInvite(id, inviteId, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.delete(`/companies/${id}/user-invites/${inviteId}`, params, validationHandler);
            return response.data;
        });
    }

    async addMembership(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/companies/${id}/memberships`, params, validationHandler);
            return response.data;
        });
    }

    async quoteMembership(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/companies/${id}/quote-memberships`, params, validationHandler);
            return response.data;
        });
    }

    async quoteCancelMembership(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/companies/${id}/quote-cancel-memberships`, params, validationHandler);
            return response.data;
        });
    }

    async cancelMembership(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/companies/${id}/cancel-memberships`, params, validationHandler);
            return response.data;
        });
    }

    async getMonthSchedule(params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/meeting-room-bookings/schedule/month`, params, validationHandler);
            return response.data;
        });
    }
}

export default new CompaniesApi();
